(function () {
  if (window.__lavCuenta) return;
  window.__lavCuenta = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function iniciar() {
    var relojes = document.querySelectorAll('[data-lav-cuenta]');
    if (!relojes.length) return;
    var fin = new Date(relojes[0].getAttribute('data-lav-cuenta')).getTime();
    if (isNaN(fin)) return;

    function pintar() {
      var resto = Math.max(0, Math.floor((fin - Date.now()) / 1000));
      var h = Math.floor(resto / 3600);
      var m = Math.floor((resto % 3600) / 60);
      var s = resto % 60;
      var texto = pad(h) + ':' + pad(m) + ':' + pad(s);
      relojes.forEach(function (r) {
        var d = r.querySelector('[data-lav-digitos]');
        if (d) d.textContent = texto;
      });
      if (resto === 0) terminar();
      return resto;
    }

    function terminar() {
      clearInterval(t);
      document.querySelectorAll('[data-lav-banner]').forEach(function (b) {
        b.classList.add('is-terminada');
        var tx = b.querySelector('.lav-banner__texto');
        var r = b.querySelector('[data-lav-cuenta]');
        if (tx && r) tx.firstElementChild.textContent = r.getAttribute('data-lav-final') || '';
      });
      document.querySelectorAll('[data-lav-oferta]').forEach(function (o) { o.hidden = true; });
    }

    var t = setInterval(pintar, 1000);
    pintar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
